import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class Filler extends React.Component {

  static propTypes = {
    document: PropTypes.object,
    onChange: PropTypes.func,
    value: PropTypes.string
  }

  renderOptions () {
    if (!this.props.document.signersRoles) return
    return this.props.document.signersRoles.map(signer => {
      return <option key={signer.name} value={signer.name}>{signer.name}</option>
    })
  }

  render () {
    return (
      <div className={styles.container}>
        <select value={this.props.value} onChange={event => this.props.onChange(event.target.value)}>
          <option value=''>Selecciona un Rol</option>
          {this.renderOptions()}
        </select>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/PrepareTemplate/Field/Menu/Filler/index.js